import {FileOpener} from '@capacitor-community/file-opener/';

const openFileMobile = (
  uri,
  fileType = 'application/pdf',
  fileName,
  FileOpenerOptions = {
    "filePath": uri,
    "contentType": fileType,
    "openWithDefault": false
  }
  
) => {
  return FileOpener.open(FileOpenerOptions)
    .then(async () => {
      return {
        status: 'ok'
      }
    })
    .catch(async () => {
      return {
        status: 'error',
        message: `Error al tratar de abrir ${fileName}`,
      };
    });
};

export default openFileMobile;